export const amountTroughBagsFormat = (
  amountTroughBags,
  formulaFractionable,
  t
) => {
  if (!amountTroughBags) return t("supplementation:not-fed");

  const amountTroughBagsString = amountTroughBags.toString().replace(".", ",");

  if (formulaFractionable) {
    return `${amountTroughBagsString} ${t("common:measure.kg")}`;
  }

  if (amountTroughBags > 1) {
    return `${amountTroughBagsString} ${t("common:measure.bags")}`;
  } else {
    return `${amountTroughBagsString} ${t("common:measure.bag")}`;
  }
};

export const troughTypeFormat = (trough, t) => {
  if (trough.creepCollection) {
    return t("supplementation:creep");
  } else if (trough.sharedTrough) {
    return t("supplementation:shared");
  } else {
    return t("supplementation:standard");
  }
};

export const pastureNamesFormat = (value) => {
  return value && typeof value.join === "function" ? value.join(" / ") : "-";
};

export const formulaNameFormat = (value, t) => {
  if (!value) return t("common:not-informed-fem");

  return value;
};
